/* Overview (Tab Mods) */

import { css } from 'styled-components';
import theme from 'theme/theme';
import { media } from 'theme/utils';
import { styleBase, styleHero, styleReverse } from '../styles';

const { colors } = theme;

const Hero = {
  key: 'Hero',
  styledComponent: css`
    ${styleHero}

    &&& {
      padding: 4.9em 0.5em 4.4em;

      div[class*='content'] {
        align-items: center;
        color: white;
        text-align: center;
      }

      div[class*='images'] {
        width: 6.2em;
      }

      ${media.md`
        padding-top: 3.3em;

        div[class*='descriptionWrapper'] {
          width: 88%;
        }
      `}

      ${media.lg`
        padding: 0;

        img {
          margin-bottom: 2.9em;
        }

        div[class*='content'] {
          height: 43em;
        }

        div[class*='images'] {
          width: 13.5em;
        }

        div[class*='descriptionWrapper'] {
          text-align: center;
        }
      `}
    }
  `,
};

const Environmental = {
  key: 'Environmental',
  styledComponent: styleBase,
};

const Social = {
  key: 'Social',
  styledComponent: css`
    ${styleBase}
    ${styleReverse}

    &&& {
      background-color: ${colors.whiteGrey};
    }
  `,
};

const Governance = {
  key: 'Governance',
  styledComponent: styleBase,
};

export const Overview = {
  key: '/responsibility',
  content: [Hero, Environmental, Social, Governance],
};

export default Overview;
